var _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooklet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 34,
    viewBox: "0 0 50 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 1,
    width: 32,
    height: 48,
    rx: 0.64,
    transform: "rotate(90 49 1)",
    stroke: "#596F93",
    strokeWidth: 1.28,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 1,
    width: 32,
    height: 12,
    rx: 0.64,
    transform: "rotate(90 49 1)",
    stroke: "#596F93",
    strokeWidth: 1.28,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1562,
    y: 1,
    width: 32,
    height: 12,
    rx: 0.64,
    transform: "rotate(90 25.1562 1)",
    stroke: "#596F93",
    strokeWidth: 1.28,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 1,
    width: 16,
    height: 48,
    rx: 0.64,
    transform: "rotate(90 49 1)",
    stroke: "#596F93",
    strokeWidth: 1.28,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooklet);
export default __webpack_public_path__ + "static/media/booklet.cdcfc8c0db1a8b677be8cf54753c1512.svg";
export { ForwardRef as ReactComponent };